module.exports = __webpack_public_path__ + "static/alternative-vision-funds-77e56cd05a8f34d20598dd516df0b062.png";